;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Controller = APP.module('Controller');
	var Router     = APP.module('Router');
	var Model      = APP.module('Model');
	var View       = APP.module('View');
	var Layout     = APP.module('Layout');
	var Collection = APP.module('Collection');

	Controller.Registration = Controller.Registration.extend({

		registerRecover: function(){
			// Build layout
			this.start('register_recover');
			//Show widgets
			var sidebar = new Layout.Sidebar({
				widgets_list: this.formBuilderData.step2_side_bar_widgets
			});

			//Add Views to regions
			this.addViewToRegions('ClubsRegisterRecover', 'register_recover', sidebar);
		}
	});

}(window, APP, Backbone, Marionette, $, _));